import { CheckoutBreadcrumbsLocalization } from "v3/services/graphql/generated";
import { CHECKOUT_STEPS } from "v3/types/checkout";

interface GetLocalizedCheckoutCrumb {
  step: CHECKOUT_STEPS;
  translations?: CheckoutBreadcrumbsLocalization | null;
  shippingMethodsEnabled?: boolean;
}

export const getLocalizedCheckoutCrumb = ({
  step,
  translations,
  shippingMethodsEnabled,
}: GetLocalizedCheckoutCrumb) =>
  ({
    [CHECKOUT_STEPS.payment]: translations?.payment || "Payment",
    [CHECKOUT_STEPS.review]: translations?.review || "Review",
    [CHECKOUT_STEPS.shippingMethod]: translations?.shipping || "Shipping",
    [CHECKOUT_STEPS.shipping]: shippingMethodsEnabled
      ? translations?.address || "Address"
      : translations?.shipping || "Shipping",
  }[step]);

export const getTimeZoneFromBrowser = (): string | undefined => {
  try {
    const res = new window.Intl.DateTimeFormat().resolvedOptions().timeZone;
    return res;
  } catch (e) {
    console.warn(`unable to get user time zone string.  e = ${e}`);
  }
};
